// TODO! MOVE TO WEB OR SOMEHWERE WHERE
const keyboardKeys = [
    "ALT",
    "CAPS_LOCK",
    "CONTROL",
    "ENTER",
    "ESCAPE",
    "FN",
    "SHIFT",
    "TAB",
    "NUM_LOCK",
    "UNKNOWN",
    "ARROW_DOWN",
    "ARROW_UP",
    "ARROW_LEFT",
    "ARROW_RIGHT",
    "END",
    "PAGE_DOWN",
    "PAGE_UP",
    "BACKSPACE",
    "DELETE",
    "HOME",
] as const;
type KeyboardKey = typeof keyboardKeys[number];

/**
 * Types the key
 * @param {KeyboardEvent} event
 * @returns {KeyboardKey}
 */

const whatKey = (event: { key: string }): KeyboardKey => {
    switch (event.key) {
        case "Alt":
            return "ALT";
        case "Shift":
            return "SHIFT";
        case "CapsLock":
            return "CAPS_LOCK";
        case "Control":
            return "CONTROL";
        case "Enter":
            return "ENTER";
        case "Tab":
            return "TAB";
        case "NumLock":
            return "NUM_LOCK";
        case "Fn":
            return "FN";
        case "Escape":
            return "ESCAPE";
        case "ArrowDown":
            return "ARROW_DOWN";
        case "ArrowUp":
            return "ARROW_UP";
        case "ArrowLeft":
            return "ARROW_LEFT";
        case "ArrowRight":
            return "ARROW_RIGHT";
        case "End":
            return "END";
        case "Home":
            return "HOME";
        case "PageDown":
            return "PAGE_DOWN";
        case "PageUp":
            return "PAGE_UP";
        case "Delete":
            return "DELETE";
        case "Backspace":
            return "BACKSPACE";
        default:
            return "UNKNOWN";
    }
};

export { whatKey, keyboardKeys };
